// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rmaReturnCustomerInformationFieldsModel } from "@guestsupply/App/Widgets/RequestRma/RequestRmaReturnInformation";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export type rmaReturnInformation = {
    customerInformation: rmaReturnCustomerInformationFieldsModel;
};
export const DispatchRmaReturnCustomerInformation: Handler<rmaReturnInformation> = props => {
    props.dispatch({
        type: "xRmaReturnInformation/SetRmaReturnInformation",
        customerInformation: props.parameter.customerInformation,
    } as any);
};

const xSetRmaReturnInformation = createHandlerChainRunner(
    [DispatchRmaReturnCustomerInformation],
    "rmaReturnCustomerInformation",
);
export default xSetRmaReturnInformation;
